import styled from 'styled-components'

type ContainerProp = {
  adjustableWidth
}

type PositionProp = {
  icon?: boolean
  tooltip?: boolean
}

export const Container = styled.div<ContainerProp>`
  display: inline-block;
  border: 1px solid #e3e6e8;
  border-radius: 6px;
  width: ${(props) => props.adjustableWidth}%;
  word-wrap: break-word;
  @media (max-width: 767px) {
    width: auto;
  }
`

export const RateText = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: #4b286d;
  display: inline-block;
  transform: translateY(-10px);
`

export const DetailsPadding = styled.div`
  @media (max-width: 767px) {
    padding-left: 8px;
  }

  > hr {
    background-color: #b2b9bf;
  }
`

export const ProductPriceTextStyle = styled.div`
  padding: 16px 0;
  > span {
    color: #4b286d;
  }
`

export const BottomTextStyle = styled.div`
  padding-top: 24px;
  padding-bottom: 52px;
  > span {
    color: #4b286d;
  }

  @media (max-width: 767px) {
    padding: 24px 0;
  }
`

export const ButtonStyle = styled.div`
  padding-top: 24px;
  padding-bottom: 52px;

  @media (max-width: 767px) {
    padding: 0 0 32px 0;
  }
`

export const Positioned = styled.div<PositionProp>`
  transform: ${(props) => `translateY(${props.icon ? '1px' : '5px'})`};
`

export const ExpandLeftShift = styled.div`
  @media (min-width: 768px) {
    transform: translateX(-40px);
  }
`

export const BottomRowPadding = styled.div`
  padding: 0 16px;

  @media (max-width: 767px) {
    padding: 0 32px;
  }
`
